<template lang="pug">
UiPage(:title="$t('automation.title')")
  .container
    UiCard
      UiCardSection
        RestTable(
          namespace="automation_list"
          :headers="headers"
          ref="automationTable"
          :initialFilters="initialFilters"
          :fetchHandler="getData"
          embed
        )
          template(#filters="{ filters, updateFilters }")
            UiCardSection
              UiStack(vertical)
                UiStack(spacing="xl")
                  UiStackItem(
                    grow
                    shrink
                  )
                    UiStack
                      UiStackItem
                        UiInputLabel(:shifted="false") {{ $t("automation.name") }}
                      UiStackItem(
                        grow
                        shrink
                      )
                        UiInput(
                          :modelValue="filters.search"
                          type="search"
                          @update:modelValue="updateFilters({ search: $event })"
                        )
                  UiStackItem(
                    grow
                    shrink
                  )
                    UiStack
                      UiStackItem
                        UiInputLabel(:shifted="false") {{ $t("automation.start_date") }}
                      UiStackItem(
                        grow
                        shrink
                      )
                        UiDatePicker(
                          :modelValue="new Date(filters.start_date)"
                          @update:modelValue="updateFilters({ start_date: startOfDay($event) })"
                        )
                  UiStackItem(
                    grow
                    shrink
                  )
                    UiStack
                      UiStackItem
                        UiInputLabel(:shifted="false") {{ $t("automation.end_date") }}
                      UiStackItem(
                        grow
                        shrink
                      )
                        UiDatePicker(
                          :modelValue="new Date(filters.end_date)"
                          @update:modelValue="updateFilters({ end_date: endOfDay($event) })"
                        )
                UiStack(spacing="xl")
                  UiCheckbox(
                    :modelValue="filters.approved"
                    switch
                    @update:modelValue="updateFilters({ approved: $event })"
                  ) {{ $t("automation.approved") }}
                  UiCheckbox(
                    :modelValue="filters.wrong_dimensions"
                    switch
                    @update:modelValue="updateFilters({ wrong_dimensions: $event })"
                  ) {{ $t("automation.wrong_dimensions") }}
                  UiCheckbox(
                    :modelValue="filters.wrong_accounts"
                    switch
                    @update:modelValue="updateFilters({ wrong_accounts: $event })"
                  ) {{ $t("automation.wrong_accounts") }}
          template(#cell:company_name="{ item }")
            RouterLink(
              :to="`/companies/${item.id}/edit?tab=automation`"
              label="item.company_name"
              v-if="item.company_name !== 'Total'"
            ) {{ item.company_name }}
            span(v-else) {{ item.company_name }}
</template>
<script>
import ApiAutomation from "@/api/automation.js";
import { addMonths } from "@/common/date_utils";
import { endOfDay, startOfDay } from "@bi-book/bibook-ui-kit";

export default {
  data() {
    const startDate = startOfDay(addMonths(new Date(), -1));
    const endDate = endOfDay(new Date());
    return {
      initialFilters: {
        approved: true,
        wrong_dimensions: false,
        wrong_accounts: false,
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      },
      headers: [
        {
          key: "company_name",
          label: "Name",
          sortable: true,
          squeeze: true,
        },
        {
          key: "netvisor_organization_id",
          label: "BusinessId",
          sortable: true,
          squeeze: true,
        },
        {
          key: "invoices_count",
          label: "Invoices",
          sortable: true,
          squeeze: true,
        },
        {
          key: "suggested_invoices_count",
          label: "Suggested Invoices",
          sortable: true,
          squeeze: true,
        },
        {
          key: "correct_invoices_perc",
          label: "Correct Invoices %",
          sortable: true,
          squeeze: true,
        },
        {
          key: "suggested_correct_invoices_perc",
          label: "Suggested Correct Invoices %",
          sortable: true,
          squeeze: true,
        },
        {
          key: "lines_count",
          label: "Invoice Lines",
          sortable: true,
          squeeze: true,
        },
        {
          key: "suggested_lines_count",
          label: "Suggested Lines",
          sortable: true,
          squeeze: true,
        },
        {
          key: "correct_lines_perc",
          label: "Correct Lines %",
          sortable: true,
          squeeze: true,
        },
        {
          key: "suggested_correct_lines_perc",
          label: "Suggested Correct Lines %",
          sortable: true,
          squeeze: true,
        },
        {
          key: "dimension_correct",
          label: "Dimension Correct Lines",
          sortable: true,
          squeeze: true,
        },

        {
          key: "dimension_correct_perc",
          label: "Dimension Correct Lines %",
          sortable: true,
          squeeze: true,
        },
        {
          key: "dimension_lines_suggested",
          label: "Dimension Lines Suggested",
          sortable: true,
          squeeze: true,
        },
      ],
    };
  },
  methods: {
    startOfDay: startOfDay,
    endOfDay: endOfDay,
    reload() {
      this.$refs.automationTable.fetchData();
    },
    getData(params, config) {
      return ApiAutomation.FetchList(params, config).then((resp) => {
        return {
          items: [...resp.data.totals, ...resp.data.companies],
          meta: resp.data.meta,
        };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-group {
  margin-bottom: 0px;
}
</style>
